import { render } from "./aboutUsPage.vue?vue&type=template&id=09c44ece&scoped=true"
import script from "./aboutUsPage.vue?vue&type=script&lang=js"
export * from "./aboutUsPage.vue?vue&type=script&lang=js"

import "./aboutUsPage.vue?vue&type=style&index=0&id=09c44ece&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c44ece"]])

export default __exports__